import React from 'react'
import { BackgroundCarosel } from './component/BackgroundCarosel'
import Header from './component/Header'
import GroupRestaurants from './component/GroupRestaurants'
import AllRestaurant from './component/AllRestaurant'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import SingleRestaurant from './component/SingleRestaurant'
import Cart from './component/Cart'
import Checkout from './component/checkout'
function App() {
  return (
    <div className="bg-black" style={{ minHeight: '100vh' }}>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<HOME />} />
          <Route path="/restaurant/:id" element={<SingleRestaurant />} />

          <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </Router>
    </div>
  )
}

export default App

const HOME = () => {
  return (
    <React.Fragment>
      <Header key={'header'} />

      <BackgroundCarosel key={'backgroundCarosel'} />
      <GroupRestaurants key={'grouprestaurant'} />
      <AllRestaurant key={'allrestaurant'} />
    </React.Fragment>
  )
}
